import React, { useCallback } from 'react';

import PropTypes from 'prop-types';
import { useDropzone } from 'react-dropzone';

import './DropzoneInput.scss';

const DropzoneInput = ({ multiple = false, accept, onFileSelected, label }) => {
    const handleDrop = useCallback((files) => {
        if (multiple) {
            onFileSelected(files);
        } else {
            onFileSelected(files[0]);
        }
    }, [multiple, onFileSelected]);

    const {
        getRootProps,
        getInputProps,
    } = useDropzone({
        onDrop: handleDrop,
        multiple,
        accept,
        label,
    });

    return (
        <div {...getRootProps({ id: 'direct_upload_dropzone', className: '' })}>
            <input {...getInputProps({ className: 'form-control' })} />
            <button type="button" className="btn btn-primary dropzone-label">{label}</button>
        </div>
    );
};

DropzoneInput.propTypes = {
    onFileSelected: PropTypes.func.isRequired,
    accept: PropTypes.object.isRequired,
    multiple: PropTypes.bool.isRequired,
    label: PropTypes.string.isRequired,
};

export default DropzoneInput;

